import { Injectable } from '@angular/core';
import type * as MonacoEditor from 'monaco-editor';
import { Observable } from 'rxjs';

@Injectable()
export class JsonEditorService {
  public getEditorErrors$(editor: MonacoEditor.editor.IStandaloneCodeEditor): Observable<string[]> {
    const editorModelUri = editor.getModel()?.uri;

    return new Observable((subscriber) => {
      const subscription = window.monaco.editor.onDidChangeMarkers(([uri]) => {
        if (uri !== editorModelUri) {
          return;
        }

        const markers = window.monaco.editor.getModelMarkers({ resource: uri });

        const errors = markers.map(
          ({ message, startLineNumber, startColumn, endLineNumber, endColumn }) =>
            `${message} [${startLineNumber}:${startColumn}-${endLineNumber}:${endColumn}]`
        );

        subscriber.next(errors);
      });

      return () => {
        subscription.dispose();
      };
    });
  }
}
